import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useIdle } from 'react-use';
import classnames from 'classnames';

import styles from './Screensaver.module.scss';

import VimeoPlayer from '../../VimeoPlayer';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { resetAllState } from '../../../slices/userSlice';

interface IScreensaverProps {
    onStateChange?: () => void;
}

const Screensaver: React.FC<IScreensaverProps> = ({ onStateChange }) => {
    const dispatch = useAppDispatch();
    const isIdle = useIdle(30000); // 90000
    const [isVisible, setVisibility] = useState(false);
    const sessionToken = useAppSelector((state) => state.users.sessionToken);

    const endDate = new Date('2025-08-31T23:59:59');
    const currentDate = new Date();
    const isExpired = currentDate > endDate;

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const channel = searchParams.get('channel');

    useEffect(() => {
        if (channel === '999993') setVisibility(true);
    }, [location.search]);

    // user is idle, show screensaver
    useEffect(() => {
        if (channel === '999993' && isIdle) {
            setVisibility(true);
            onStateChange && onStateChange();
            dispatch(resetAllState());
        }
    }, [channel, isIdle]);

    return isVisible && !sessionToken ? (
        <div className={styles.screensaver}>
            <VimeoPlayer
                className={classnames(styles.video, isExpired && styles.expired)}
                video={'1090425904'}
                options={{
                    playsinline: true,
                    autoplay: true,
                    responsive: true,
                    muted: true,
                    autopause: false,
                    loop: true
                }}
            />
            <div
                onClick={() => (isExpired ? {} : setVisibility(false))}
                className={styles.overlay}
            />
        </div>
    ) : null;
};

export default Screensaver;
